import { ENTITY } from 'src/consts'

export default class Drawer {
  oldData = {
    groups: [],
    leaves: [],
  }

  setProps({
    canvas,
    colorScale,
    width,
    height,
    globalSearchSymbol,
    baseValue,
    entity,
  }) {
    this.canvas = canvas || this.canvas
    this.colorScale = colorScale || this.colorScale
    this.ctx = this.canvas.getContext('2d')
    this.width = width || this.width
    this.height = height || this.height
    this.globalSearchSymbol = globalSearchSymbol || this.globalSearchSymbol
    this.baseValue = baseValue || this.baseValue
    this.entity = entity || this.entity
  }

  setTarget(target) {
    this.target = target
  }

  redrawWithOldData() {
    // eslint-disable-next-line @typescript-eslint/no-extra-semi
    ;['groups', 'leaves'].forEach(type => {
      this.draw(this.oldData[type], type, false)
    })
  }

  clear() {
    this.ctx?.clearRect(0, 0, this.width, this.height)
  }

  draw(data, type, newData = true) {
    if (newData) {
      this.oldData[type] = data
    }

    const colors = {}

    let changeField = 'change'

    if (
      this.entity === ENTITY.EXCHANGE &&
      this.baseValue === 'volumeReported'
    ) {
      changeField = 'changeReported'
    }

    /* Prepare sets */
    data.forEach(d => {
      const selected =
        this.target && this.target.data
          ? d.data.name === this.target.data.name
          : false
      let colorValue = 'transparent'

      if (d.height === 0) {
        /* Leaves */
        const searched =
          this.globalSearchSymbol && typeof this.globalSearchSymbol === 'string'
            ? d.data.symbol === this.globalSearchSymbol
            : false

        colorValue = searched
          ? '#3d57d2'
          : this.colorScale(
              Math.round(d.data[changeField] * 100) / 100
            ).toString()
      }

      if (colors[colorValue]) {
        colors[colorValue].push(d)
      } else {
        colors[colorValue] = [d]
      }
    })

    Object.entries(colors).forEach(([color, itemsArr]) => {
      this.ctx.fillStyle = color
      itemsArr.forEach(d => {
        this.drawItem(d)
      })
    })
  }

  drawItem(d) {
    window['grid_params'][d.data.symbol] = {
      x0: d.x0,
      y0: d.y0,
      x1: d.x1,
      y1: d.y1,
      width: d.x1 - d.x0,
      height: d.y1 - d.y0,
      symbol: d.data.symbol,
    }

    const width = d.x1 - d.x0
    const height = d.y1 - d.y0

    this.ctx.fillRect(d.x0, d.y0, width, height)
  }
}
